import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import useOnceEffect from "../../Hooks/useOnceEffect";
import cursos_default from '../../static/images/cursos_default.png'
import { Url } from "../../utils/Url/Url";

function DetalleCurso() {
  const params = useParams();
  let history = useHistory();
  const [course, setcourse] = useState("");

  useOnceEffect(() => {
    if (params.id === undefined) {
      toast.error("Curso no disponible", {
        duration: 5000,
      });
      setTimeout(function () {
        history.push("/user/Home");
      }, 6000);
    }

    const getData = () => {
      axios.get("company-course/" + params.id).then((result) => {
        setcourse(result.data);
      });
    };

    getData();
  });

  const ppBanner = {
    width: "100%",
    height: "100%",
    backgroundImage: `url(${cursos_default})`,
    backgroundSize: "contain",
    minHeight: "200px",
    minWidth: "200px"
  };

  return (
    <div
      id="coursesD"
      className="vacantes perfil-empresa"
      style={{ marginBottom: "50px" }}
    >
      <div className="container">
        <div className="row">
          <div className="body-profile">
            <div className="profile__header">
              <div className="profile__header-container">
                <div className="profile__cover-photo">
                  <img
                    id="bannerPic"
                    src={course.coverImage}
                    className="no-cover-image"
                    alt="No cover"
                    style={ppBanner}
                  ></img>
                </div>
                <div className="profile__header-info">
                  <div className="profile__header-info-left">
                    <div className="profile__header-info-left-wrapper">
                      <div className="profile__header-info-photo box-imgCat">
                        <img
                          id="bannerPic"
                          src={course.image}
                          className="no-cover-image"
                          alt="no cover"
                          style={ppBanner}
                        ></img>
                      </div>
                      <div className="profile__header-info-description">
                        <div className="profile__header-info-description-name">
                          {course.nombre}
                          <br />
                          Publicado por: {course?.companyProfileId?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="profile__header-info-right">
                    
                    <div className="profile__header-info-right-wrapper">
                      
                      <div className="profile__header-info-right-button justify-content-end">
                        <a href="#" class=" btn--gradient btn--gradient-small py-2 px-3"
                        onClick={()=>{
                          let host = window.location.hostname;
                              //in the case host having a port, include it in the url
                              if(window.location.port){
                                host = host + ":" + window.location.port
                              }

                              // Asegurarse de que el protocolo sea https
                              let protocol = window.location.protocol === "https:" ? "https" : "http";

                              let finalUrl = `${protocol}://${host}/compartir/curso/${course.companyCourseId}`
                              let Title = `${course?.companyProfileId?.name} :${course.nombre}`
                              let body = 'Te comparto este curso que encontré en Krezco, la red social de desarrollo profesional';
                              navigator.share({
                                title: Title,
                                url: finalUrl,
                                text: body
                              })
                        }}
                        >
                          <i className="fas fa-share-alt text-xl text-white"></i>
                        </a>
                        <a
                          href={ Url(course.url)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn--gradient btn--gradient-small"
                        >
                          Ir al curso
                        </a>
                      </div>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row vacancy__content">
          <div className="col-12 col-md-5">
            <div className="vacancy__sidebar bordered-box mt-0">
              <div className="bordered-box__header">
                <div className="bordered-box__header-title">Información</div>
              </div>
              <div className="course__sidebar-content">
                <ul>
                  <li>
                    <strong>Fecha Inicio:</strong>{" "}
                    <span>{course.fechaPublicacion}</span>
                  </li>
                  <li>
                    <strong>Fecha Finalizacion:</strong>{" "}
                    <span>{course.fechaFinal}</span>
                  </li>
                  <li>
                    <strong>Ubicación:</strong> <span>{course.direccion}</span>
                  </li>
                  <li>
                    <strong>Tipo:</strong>{" "}
                    <span>{course.formationCourseId?.name ?? ""}</span>
                  </li>
                  <li>
                    <strong>Formación:</strong>{" "}
                    <span>
                      {course.formacion !== ""
                        ? course.formacion
                        : "Cualquiera"}
                    </span>
                  </li>
                  <li>
                    <strong>Nivel:</strong>{" "}
                    <span>{course.nivelCourseId?.name ?? ""}</span>
                  </li>
                  <li>
                    <strong>Sector:</strong>{" "}
                    <span>{course.sectorId?.name ?? ""}</span>
                  </li>
                  <li>
                    <strong>Modalidad:</strong>{" "}
                    <span>{course.modalidadCourseId?.name ?? ""}</span>
                  </li>
                  <li>
                    <strong>Hora Inicio:</strong> <span>{course.hora}</span>
                  </li>
                  <li>
                    <strong>Idioma:</strong>{" "}
                    <span>{course.language?.description ?? ""}</span>
                  </li>
                  <li>
                    <strong>Duracion:</strong> <span>{course.duracion}</span>
                  </li>
                  <li>
                    <strong>Contacto:</strong>{" "}
                    <span>
                      {course.contacto + " " + course.telefonoContacto}
                    </span>
                  </li>
                  <li>
                    <strong>Url:</strong> <span>{course.url}</span>
                  </li>
                  <li>
                    <strong>Inversion:</strong> <span>{course.inversion}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="bordered-box mt-0">
              <div className="bordered-box__header-title">
                Descripción del curso
              </div>
              <p>{course.descripcion}</p>
              <hr className="mt-5" />
              <div className="bordered-box__header-title">
                Habilidades a Desarrollar / Requisitos
              </div>
              <p>{course.habilidadesCompartidas}</p>
              <p>{course.requisitos}</p>
              <hr className="mt-5" />
              <div className="bordered-box__header-title">Tematica</div>
              <p>{course.tematica}</p>
              <hr className="mt-5" />
              <div className="bordered-box__header-title">Dirigido</div>
              <p>{course.dirigido}</p>
              <hr className="mt-5" />
              <div className="bordered-box__header-title">Incluye</div>
              <p>{course.incluye}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetalleCurso;
